export default {
  MOVIES_IMG_CONF: 'https://image.tmdb.org/t/p/w154/',
  TRENDING_IMG_CONF: 'https://image.tmdb.org/t/p/w1280',
  LAZY_IMG_CONF: 'https://image.tmdb.org/t/p/w45',
  LAZY_IMG_CONF_MAIN: 'https://image.tmdb.org/t/p/w92',
  NO_POSTER_IMG: 'https://dummyimage.com/45x68/000/fff&text=no+poster',
  ORIGINAL_POSTER: 'https://image.tmdb.org/t/p/original',
  TRAILER_CONFIG: 'https://www.youtube.com/embed/',
  DEFAULT_PERSON_PHOTO: 'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80',
  DUMMY_IMAGE_SEARCH_SOURCE: 'https://dummyimage.com/154x233/000/ededed.jpg&text=no+image',
  SIGN_UP_USER_PARAMS: 'https://www.googleapis.com/identitytoolkit/v3/relyingparty/signupNewUser?key=',
  VERIFY_PASSWORD: 'https://www.googleapis.com/identitytoolkit/v3/relyingparty/verifyPassword?key=',
};
